import { setRecoil } from 'recoil-nexus';

import {
  ambientListeningIntelligenceChatId,
  currentActiveStepID,
  emCPTsText,
  enhanceAmbientListeningLoading,
  enhancedNote,
  preSelectedNoteType
} from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/state';

const updateAmbientListening = (data) => {
  const { done = false, abort = false, note, noteType, emCPTsText: emCodesText, ...rest } = data;

  try {
    if (done || abort) {
      setRecoil(preSelectedNoteType, noteType);
      setRecoil(enhanceAmbientListeningLoading, false);
      setRecoil(enhancedNote, note);
      setRecoil(emCPTsText, emCodesText);
      if (abort) {
        setRecoil(currentActiveStepID, 2);
      } else {
        setRecoil(currentActiveStepID, 3);
      }
    }

    if (rest?.intelligence_chat_id) {
      setRecoil(ambientListeningIntelligenceChatId, rest?.intelligence_chat_id);
    }
  } catch (error) {
    console.error('❌ Error', error);
  }
};

export default updateAmbientListening;
